import api from "./api";

/**
 * Login with username and password
 * @param {Object} credentials - { username, password }
 * @returns {Promise<Object>} User data
 */
export async function login({ username, password }) {
  const { data } = await api.post("/trading/auth/login", { username, password });
  
  if (!data.isSuccessful) {
    const errorMessage = data.getMessageText?.join(", ") || data.message?.[0]?.messageText || "ورود ناموفق بود";
    throw new Error(errorMessage);
  }
  
  return data.data;
}

/**
 * Register with mobile number
 * @param {Object} params - { phoneNumber }
 * @returns {Promise<Object>} Response data (usually contains token for verification)
 */
export async function mobileRegister({ phoneNumber }) {
  const { data } = await api.post("/trading/auth/mobileregister", { phoneNumber });
  
  if (!data.isSuccessful) {
    const errorMessage = data.getMessageText?.join(", ") || data.message?.[0]?.messageText || "ثبت نام ناموفق بود";
    throw new Error(errorMessage);
  }
  
  return data.data;
}

/**
 * Login with mobile number (sends OTP)
 * @param {Object} params - { phoneNumber }
 * @returns {Promise<Object>} Response data (usually contains token for verification)
 */
export async function mobileLogin({ phoneNumber }) {
  const { data } = await api.post("/trading/auth/mobilelogin", { phoneNumber });
  
  if (!data.isSuccessful) {
    const errorMessage = data.getMessageText?.join(", ") || data.message?.[0]?.messageText || "ورود ناموفق بود";
    throw new Error(errorMessage);
  }
  
  return data.data;
}

/**
 * Verify login with token and code (OTP verification)
 * @param {Object} params - { token, code }
 * @returns {Promise<Object>} User data
 */
export async function verifyLogin({ token, code }) {
  const { data } = await api.post("/trading/auth/verifylogin", { token, code });
  
  if (!data.isSuccessful) {
    const errorMessage = data.getMessageText?.join(", ") || data.message?.[0]?.messageText || "تایید ناموفق بود";
    throw new Error(errorMessage);
  }
  
  return data.data;
}

/**
 * Verify register with token and code (OTP verification for registration)
 * @param {Object} params - { token, code }
 * @returns {Promise<Object>} Response data (contains verificationToken, status, roleType, expireTime)
 */
export async function verifyRegister({ token, code }) {
  const { data } = await api.post("/trading/auth/verifyregister", { token, code });
  
  if (!data.isSuccessful) {
    const errorMessage = data.getMessageText?.join(", ") || data.message?.[0]?.messageText || "تایید ثبت نام ناموفق بود";
    throw new Error(errorMessage);
  }
  
  return data.data;
}

export async function me() {
  const { data } = await api.get("/auth/me");
  return data.user;
}

export async function logout() {
  await api.post("/auth/logout");
}

export async function refresh() {
  await api.post("/auth/refresh");
}

export async function setPassword({ password, confirmPassword, name, city, address, description, businessLicenseImage }) {
  const { data } = await api.post("/auth/set-password", { password, confirmPassword, name, city, address, description, businessLicenseImage });
  
  if (!data.isSuccessful) {
    const errorMessage = data.getMessageText?.join(", ") || data.message?.[0]?.messageText || "تنظیم رمز عبور ناموفق بود";
    throw new Error(errorMessage);
  }
  
  return data.data || data;
}

/**
 * Admin resets a user's password
 */
export async function adminResetPassword(userId, newPassword) {
  try {
    const { data } = await api.put(`/auth/admin/reset-password/${userId}`, { newPassword });
    return data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'تغییر رمز عبور ناموفق بود';
    throw new Error(message);
  }
}

/**
 * User changes their own password
 */
export async function changePassword(currentPassword, newPassword) {
  try {
    const { data } = await api.put("/auth/change-password", { currentPassword, newPassword });
    return data;
  } catch (error) {
    const message = error.response?.data?.message || error.message || 'تغییر رمز عبور ناموفق بود';
    throw new Error(message);
  }
}


